import styled from 'styled-components';
import { breakpoints, css } from 'src/styles/theme';
import { FeatureDemandBannerStyled } from '../FeatureDemandBannerStyled';
import { rem } from 'polished';

export const FeatureDemandBannerDS = styled(FeatureDemandBannerStyled)`
    border-radius: ${rem(16)};
    background: ${({ theme }) => theme.colors.accordionAnswer};
    background-size: cover;

    .label {
        text-transform: uppercase;
        color: ${({ theme }) => theme.colors.primary};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
    }

    .title {
        color: ${({ theme }) => theme.colors.white};

        ${({ isBasketPage }) =>
            isBasketPage &&
            css`
                @media (min-width: ${breakpoints.md}px) {
                    font-size: ${rem(32)};
                    line-height: ${rem(44)};
                }
            `}
    }

    .link {
        text-decoration: underline;
        color: ${({ theme }) => theme.colors.white};
        cursor: pointer;
    }
`;
